import { fetchAny, fetchJSON } from './fetch'

export const getConfiguration = () => {
  return fetchJSON.get('/settings') // eslint-disable-line
}

export const getStreams = () => {
  return fetchJSON.get('/streams') // eslint-disable-line
}

export const getTeamStreams = team => {
  return fetchJSON.get('/team', { team }) // eslint-disable-line
}

export const getCommands = name => {
  return fetchJSON.get(`/commands/${name.trim().toLowerCase()}`)
}

export const getTags = () => {
  return fetchJSON.get('/tags') // eslint-disable-line
}

export const getUserData = () => {
  return fetchJSON.get(`/user`) // eslint-disable-line
}

export const logOut = () => {
  return fetchAny.get(`/logout`) // eslint-disable-line
}

export const getPreferences = () => {
  return fetchJSON.get(`/preferences`) // eslint-disable-line
}

export const setPreferences = prefs => {
  return fetchJSON.post(`/preferences`, prefs) // eslint-disable-line
}



// WEBPACK FOOTER //
// ./src/api/index.js